import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ShownDirective } from './directives/shown.directive';
import { DebounceDirective } from './directives/debounce.directive';
import { RequireRoleDirective } from './directives/require-role.directive';
import { RequireAccessDirective } from './directives/require-access.directive';
import { UsernamePipe } from './pipes/username.pipe';
import { RunZoneDirective } from './directives/run-zone.directive';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { FilterByPipe } from './pipes/filter-by.pipe';
import { ResizeObserverDirective } from './directives/resize-observer.directive';
import { StickyScrollDirective } from './directives/sticky-scroll.directive';

@NgModule({
  declarations: [
    ShownDirective,
    DebounceDirective,
    RequireRoleDirective,
    RequireAccessDirective,
    UsernamePipe,
    TimeAgoPipe,
    FilterByPipe,
    RunZoneDirective,
    ResizeObserverDirective,
    StickyScrollDirective,
  ],
  imports: [CommonModule, MatIconModule],
  exports: [
    ShownDirective,
    DebounceDirective,
    RequireRoleDirective,
    RequireAccessDirective,
    UsernamePipe,
    TimeAgoPipe,
    FilterByPipe,
    RunZoneDirective,
    MatIconModule,
    ResizeObserverDirective,
    StickyScrollDirective,
  ],
})
export class SharedModule {}
